module.exports = __webpack_public_path__ + "img/Cutaways_house_4_tile.e3389fc2.jpg";